export default __webpack_public_path__ + "static/media/bg-elite-full.c08b4fd2.svg";